import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component( {
    selector: 'his-display-email',
    templateUrl: './his-display-email.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisDisplayEmailComponent {
    @Input() value: string;
}
